// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"966445c8","153":"1ff33bbb","169":"45c07a88","204":"4be4478d","285":"ce7ccaa7","359":"ed48db3b","396":"f494dcb7","434":"388751d3","639":"86c1968e","888":"9163c568"}[chunkId] + ".chunk.js";
};